import { Lightbulb } from "lucide-react";
export const LlmIntegrationTakeaway = () => (
  <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent rounded-2xl border border-primary/20 p-6 sm:p-8">
    <div className="flex items-start gap-4">
      <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center shrink-0"><Lightbulb className="w-6 h-6 text-primary" /></div>
      <div><h3 className="text-lg font-semibold text-foreground mb-2">Key Takeaway</h3>
        <p className="text-muted-foreground leading-relaxed">Don't just call the API — build a robust integration with caching, fallbacks, and cost controls. The difference between a demo and production is error handling.</p>
      </div>
    </div>
  </div>
);
